import sortDocumentTypes from '@sort-group/sort-document-types';
import pickBy from 'lodash/pickBy';

export default (requiredDocument) => {
  return Object.keys(requiredDocument).length !== 0 &&
    Object.keys(requiredDocument.documentTypes).length !== 0 &&
    !requiredDocument.showAllDocumentTypes
    ? pickBy(sortDocumentTypes, (value, key) => {
        return sortObjectByValues(Object.keys(requiredDocument.documentTypes).includes(key));
      })
    : sortObjectByValues(sortDocumentTypes);
};

function sortObjectByValues(obj) {
  return Object.entries(obj)
    .sort((a, b) => a[1].localeCompare(b[1]))
    .reduce((c, v) => ({ ...c, [v[0]]: v[1] }), {});
}
